import React from 'react';
import { Link } from 'react-router-dom';
import showcaseImage from '../assets/showcase.svg';
import heroBg from '../assets/herobg2.png';
import jenny from '../assets/jenny.jpg';
import peter from '../assets/peter.jpg';
import emily from '../assets/emily.jpg';
import linkedinIcon from '../assets/linkedin.png';
import heroImageSrc from '../assets/hero.png'; // Import the hero image source
import mattieImage from '../assets/mattie.jpg'; // Add this image to assets
import bradfordImage from '../assets/bradford.jpg'; // Add this image to assets
import majkinImage from '../assets/majkin.jpg'; // Add this image to assets

function Home() {
  return (
    <>
      {/* Hero Section */}
      <section
        className="py-20 md:py-32 lg:py-40 flex flex-col lg:flex-row items-center justify-center bg-[#51c0a6] bg-cover bg-center px-4 sm:px-8 lg:px-48" // Use flex-row on large screens, add padding
      >
        {/* Left Column: Text and CTA */}
        <div className="lg:w-3/5 text-center lg:text-left mb-12 lg:mb-0 lg:pr-12"> {/* Define width, alignment, spacing */}
          <h1 className="font-heading text-4xl mb-6 text-white">
            Entrepreneurship Education for Creators
          </h1>
          <p className="font-body md:text-xl mb-8 text-white"> {/* Removed width constraints */}
           We provide a business and entrepreneurship education to creators and artists through a digital, ai-powered platform with accessible content, powerful case-studies, active learning exercises, and individualized feedback and strategy.
          </p>
          <div className="flex justify-center lg:justify-start space-x-4"> {/* Adjust button alignment */}
            <Link to="/register">
              <button className="font-body bg-white text-black px-8 py-3 rounded-md text-lg hover:bg-opacity-90 transition">
                Get Started
              </button>
            </Link>
            <Link to="mailto:peter@makerstate.com">
              <button className="font-body bg-white text-black px-8 py-3 rounded-md text-lg hover:bg-opacity-90 transition">
                Contact
              </button>
            </Link>
          </div>
        </div>

        {/* Right Column: Image */}
        <div className="lg:w-2/5 flex justify-center lg:justify-end"> {/* Define width and alignment */}
          {/* Render the imported hero image using an img tag */}
          <img
            src={heroImageSrc}
            alt="Hero illustration"
            className="rounded-md w-3/4 max-w-md md:max-w-lg lg:max-w-xl h-auto" // Adjust size as needed
          />
        </div>
      </section>

      {/* Features Section */}
        <section className="py-16 bg-gray-50 flex items-center justify-center">
          <div className="container mx-auto px-4 text-center">
            <h2 className="font-heading w-full md:w-1/3 text-3xl md:text-4xl mb-6 mx-auto">
          A New Way Forward
            </h2>
            <p className="font-body text-base md:text-xl mb-12 text-gray-500 w-11/12 md:w-1/2 mx-auto">
            Traditional methods of producing and selling art are exclusionary and
            extractive of the artist. We provide practical and easy-to-use skills to build a sustainable career around your creative work while retaining ownership of your ideas.
            </p>
            <div className="flex flex-wrap justify-center -mx-4">
          {/* Feature 1 */}
            <div className="w-full md:w-1/3 px-2 mb-8">
              <div className="border border-gray-200 bg-white p-16 rounded-3xl text-center transition">
                <div className="text-4xl mb-4">🎯</div>
                <h3 className="font-heading text-2xl mb-2">Guided Learning</h3>
                <p className="font-body text-gray-500">
                  Learn the 24 steps of <a className="text-customGreen" href="https://www.d-eship.com/" target="_blank">Disciplined Entrepreneurship</a> with structured chapters and active learning.
                </p>
                </div>
                </div>
                {/* Feature 2 */}
            <div className="w-full md:w-1/3 px-2 mb-8">
              <div className="border border-gray-200 bg-white p-16 rounded-3xl text-center transition">
                <div className="text-4xl mb-4">💡</div>
                <h3 className="font-heading text-2xl mb-2">Innovative Ideas</h3>
                <p className='font-body text-gray-500'>Discover how to turn creative IP into scalable businesses and financial sustainability.</p>
              </div>
            </div>
            {/* Feature 3 */}
            <div className="w-full md:w-1/3 px-2 mb-8">
              <div className="border border-gray-200 bg-white p-16 rounded-3xl text-center transition">
                <div className="text-4xl mb-4">🤝</div>
                <h3 className="font-heading text-2xl mb-2">Community Support</h3>
                <p className='font-body text-gray-500'>Join a community of like-minded creatives and entrepreneurs and build together.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Showcase Section */}
      <section
        className="py-48 bg-cover bg-center bg-customGreen lg:bg-showcase"
      >
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center">
            <div className="w-full lg:w-1/3 mb-12 lg:mb-0">
              <h2 className="text-3xl md:text-4xl text-white font-heading mb-6">See Makerstate in Action</h2>
              <p className="font-body text-white mb-6 text-base md:text-xl">
                Explore how our platform transforms the way you create and share your work.
              </p>
              <Link
                to="/register"
                className="inline-block bg-white text-black px-8 py-3 rounded-md text-lg font-body hover:bg-opacity-90 transition"
              >
                Sign Up Now
              </Link>
            </div>
            <div className="w-full lg:w-1/2">
              {/* Optional: Add an image or graphic here if desired */}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-heading text-center mb-12">
            What Creators Are Saying
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Testimonial 1 */}
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 flex flex-col">
              <p className="font-body text-gray-600 italic mb-6 flex-grow">
              "Creating your dreams doesn't have to feel so isolating and insurmountable."           </p>
              <div className="flex items-center mt-auto">
                <img src={mattieImage} alt="Mattie Jo Cowsert" className="w-12 h-12 rounded-full mr-4 object-cover"/>
                <div>
                  <p className="font-semibold font-body text-gray-800">Mattie Jo Cowsert</p>
                  <p className="text-sm font-body text-gray-500">Author of <span className='italic'>God, Sex, and Rich People</span></p>
                </div>
              </div>
            </div>
            {/* Testimonial 2 */}
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 flex flex-col">
              <p className="font-body text-gray-600 italic mb-6 flex-grow">
                "It was almost like a slap in the face or a kick in the butt. This is what you should be doing. I was quite amazed."
              </p>
              <div className="flex items-center mt-auto">
                <img src={bradfordImage} alt="Bradford Tilden" className="w-12 h-12 rounded-full mr-4 object-cover"/>
                <div>
                  <p className="font-semibold font-body text-gray-800">Bradford Tilden</p>
                  <p className="text-sm font-body text-gray-500">Composer and Best-Selling Author</p>
                </div>
              </div>
            </div>
            {/* Testimonial 3 */}
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 flex flex-col">
              <p className="font-body text-gray-600 italic mb-6 flex-grow">
                "I genuinely do learn something new every week that I'm like, ooh, that's what that is."
              </p>
              <div className="flex items-center mt-auto">
                <img src={majkinImage} alt="Majkin Holmquist" className="w-12 h-12 rounded-full mr-4 object-cover"/>
                <div>
                  <p className="font-semibold font-body text-gray-800">Majkin Holmquist</p>
                  <p className="text-sm font-body text-gray-500">Playwright and Producer of <span className='italic'>Stargazers</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Organizational CTA Section */}
      <section className="py-20 bg-customGreen text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-heading mb-6 max-w-2xl mx-auto">
            Empower Your Creative Community
          </h2>
          <p className="font-body text-base md:text-xl mb-8 max-w-4xl mx-auto">
            Partner with Makerstate to provide your artists, students, or members with essential entrepreneurial skills. We offer tailored solutions for universities, nonprofits, and foundations.
          </p>
          <Link
            to="/pricing#partners"
            className="inline-block bg-white text-black px-8 py-3 rounded-md text-lg font-body transition"
          >
            Learn About Partnerships
          </Link>
        </div>
      </section>

      {/* Partners Logos Section - ADD THIS SECTION */}
      <section className="hidden py-12 bg-gray-100"> {/* Thinner padding, light background */}
        <div className="container mx-auto px-4">
          <h3 className="text-center text-base md:text-xl font-body text-gray-500 mb-8">
            Trusted by Leading Organizations
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-6 md:gap-x-12 lg:gap-x-16 text-gray-500"> {/* Added text-gray-500 for SVG fill */}
            {/* Fake Logo 1: Overlapping Circles */}
            <svg className="h-8 md:h-10" viewBox="0 0 100 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20" r="18" opacity="0.7"/>
              <circle cx="50" cy="20" r="18" opacity="0.7"/>
              <circle cx="80" cy="20" r="18" opacity="0.7"/>
            </svg>

            {/* Fake Logo 2: Abstract Lines */}
            <svg className="h-8 md:h-10" viewBox="0 0 100 40" fill="none" stroke="currentColor" strokeWidth="4" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 10 Q 30 30, 50 10 T 90 30" />
              <path d="M10 30 Q 30 10, 50 30 T 90 10" />
            </svg>

            {/* Fake Logo 3: Simple Wordmark "NEXUS" */}
            <svg className="h-8 md:h-10" viewBox="0 0 120 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <text x="0" y="30" fontFamily="Arial, sans-serif" fontSize="30" fontWeight="bold">NEXUS</text>
            </svg>

            {/* Fake Logo 4: Stylized Gear */}
            <svg className="h-8 md:h-10" viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 0 L24 4 L22 8 L26 10 L24 14 L28 16 L28 24 L24 28 L26 30 L22 32 L24 36 L20 40 L16 36 L18 32 L14 30 L16 28 L12 24 L12 16 L16 14 L14 10 L18 8 L16 4 Z M20 12 A 8 8 0 1 0 20 28 A 8 8 0 1 0 20 12 Z"/>
            </svg>

            {/* Fake Logo 5: Triangle Pattern */}
            <svg className="h-8 md:h-10" viewBox="0 0 100 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <polygon points="10,35 30,5 50,35" opacity="0.8"/>
              <polygon points="40,35 60,5 80,35" opacity="0.8"/>
              <polygon points="70,35 90,5 110,35" opacity="0.8"/>
            </svg>
            {/* Add more logos as needed */}
          </div>
        </div>
      </section>
      {/* END: Partners Logos Section */}

      {/* Donor/Sponsor CTA Section */}
      <section className="py-20 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-heading mb-6 max-w-2xl mx-auto">
            Support the Next Generation of Creators
          </h2>
          <p className="font-body text-base md:text-xl mb-8 text-white max-w-4xl mx-auto">
            Your contribution can provide an emerging artist with full access to Makerstate's resources, including personalized coaching. Help us build a more sustainable future for the arts.
          </p>
          <Link
            to="https://drive.google.com/file/d/1rvKsV9By4od8qfjaCNGMEabqpQDJCZfS/view?usp=sharing" // Link to sponsorship/donation page or contact
            className="inline-block bg-white text-black px-8 py-3 rounded-md text-lg font-body transition"
            target="_blank" // Open in new tab
          >
            Sponsor an Artist
          </Link>
        </div>
      </section>

      {/* Supporters Section - ADD THIS SECTION */}
      <section className="py-3 bg-white hidden"> {/* Simple background */}
        <div className="container mx-auto">
          {/* Simple scrolling container - enhance with animation later if desired */}
          <div className="relative overflow-hidden"> {/* Optional: for potential future fading edges */}
            <div className="flex space-x-8 animate-marquee whitespace-nowrap"> {/* Adjust space-x-* as needed */}
              {/* Repeat names or add more to fill space for scrolling effect */}
              <span className="text-lg font-body text-gray-700">Jane Doe</span>
              <span className="text-lg font-body text-gray-700">John Smith</span>
              <span className="text-lg font-body text-gray-700">The Art Foundation</span>
              <span className="text-lg font-body text-gray-700">Creative Futures Fund</span>
              <span className="text-lg font-body text-gray-700">Michael Lee</span>
              <span className="text-lg font-body text-gray-700">Sarah Chen</span>
              <span className="text-lg font-body text-gray-700">Anonymous Donor</span>
              <span className="text-lg font-body text-gray-700">Supporters Inc.</span>
              {/* Duplicate the list for a seamless loop effect with CSS animation */}
              <span className="text-lg font-body text-gray-700">Jane Doe</span>
              <span className="text-lg font-body text-gray-700">John Smith</span>
              <span className="text-lg font-body text-gray-700">The Art Foundation</span>
              <span className="text-lg font-body text-gray-700">Creative Futures Fund</span>
              <span className="text-lg font-body text-gray-700">Michael Lee</span>
              <span className="text-lg font-body text-gray-700">Sarah Chen</span>
              <span className="text-lg font-body text-gray-700">Anonymous Donor</span>
              <span className="text-lg font-body text-gray-700">Supporters Inc.</span>
            </div>
          </div>
        </div>
      </section>
      {/* END: Supporters Section */}

      {/* Team & Mentors Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-heading mb-6 max-w-2xl mx-auto">
            Our Team
          </h2>
          <p className="font-body text-base md:text-xl mb-8 max-w-3xl mx-auto">
            We are the perfect blend of artists and entrepreneurs to teach you how to build a sustainable career around your creative work.
          </p>
          {/* Add lg:justify-center here */}
          <div className="flex flex-col lg:flex-row lg:space-x-12 lg:justify-center"> {/* Main container for two columns */}

            {/* Team Column */}
            <div className="lg:w-1/3 mb-12 lg:mb-0 text-left"> {/* Keep width as 1/3 */}
              <div className="space-y-4"> {/* Reduced spacing between cards */}
                {/* Jenny Larios Berlin - Horizontal Card */}
                <a
                  href="https://www.linkedin.com/in/jenny-larios-berlin/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-white rounded-md overflow-hidden border border-gray-200 hover:border-gray-300 transition"
                >
                  <div className="flex items-center p-3"> {/* Reduced padding */}
                    <img
                      src={jenny}
                      alt="Jenny Larios Berlin"
                      className="w-16 h-16 object-cover rounded-md mr-3" // Reduced image size and margin
                    />
                    <div className="flex-grow">
                      <h3 className="text-base font-heading mb-0.5 text-gray-900">Jenny Larios Berlin</h3> {/* Reduced text size */}
                      <p className="font-body text-base text-gray-500 mb-1">Founder / CEO</p> {/* Reduced text size and margin */}
                      {/* LinkedIn icon and specific link removed */}
                    </div>
                  </div>
                </a>

                {/* Emily Roller - Horizontal Card */}
                <a
                  href="https://www.linkedin.com/in/emily-roller-20646825/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-white rounded-md overflow-hidden border border-gray-200 hover:border-gray-300 transition"
                >
                  <div className="flex items-center p-3"> {/* Reduced padding */}
                    <img
                      src={emily}
                      alt="Emily Roller"
                      className="w-16 h-16 object-cover rounded-md mr-3" // Reduced image size and margin
                    />
                    <div className="flex-grow">
                      <h3 className="text-base font-heading mb-0.5 text-gray-900">Emily Roller</h3> {/* Reduced text size */}
                      <p className="font-body text-base text-gray-500 mb-1">Founder / CPO</p> {/* Reduced text size and margin */}
                      {/* LinkedIn icon and specific link removed */}
                    </div>
                  </div>
                </a>

                {/* Peter Li - Horizontal Card */}
                <a
                  href="https://www.linkedin.com/in/zpli/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-white rounded-md overflow-hidden border border-gray-200 hover:border-gray-300 transition"
                >
                  <div className="flex items-center p-3"> {/* Reduced padding */}
                    <img
                      src={peter}
                      alt="Peter Li"
                      className="w-16 h-16 object-cover rounded-md mr-3" // Reduced image size and margin
                    />
                    <div className="flex-grow">
                      <h3 className="text-base font-heading mb-0.5 text-gray-900">Peter Li</h3> {/* Reduced text size */}
                      <p className="font-body text-base text-gray-500 mb-1">Founder / Software Engineer</p> {/* Reduced text size and margin */}
                      {/* LinkedIn icon and specific link removed */}
                    </div>
                  </div>
                </a>

              </div>
            </div>

          </div>
        </div>
      </section>
      {/* END: Team & Mentors Section */}

    </>
  );
}

export default Home;
